import { Hero } from "@/components/home/Hero";
import { NewRange } from "@/components/home/NewRange";
import { IndexList } from "@/components/home/IndexList";
import { Heritage } from "@/components/home/Heritage";
import { Industries } from "@/components/home/Industries";
import { Marquee } from "@/components/site/Marquee";
import { ContactBand } from "@/components/site/ContactBand";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <NewRange />
      <IndexList />
      <Heritage />
      <Industries />
      <ContactBand />
    </div>
  );
}
